import { observer } from "mobx-react";
import React, { useEffect } from "react";

import { Bob } from "../../stores/Bob";
import SetReceiveAmount from "./SetReceiveAmount";
import SingleBobNostrConnection from "../nwc/singleBobNostrConnection";
import SetUserProvidedNostrPublicKey from "./SetUserProvidedNostrPublicKey";
import EditAliasModal from "./EditAliasModal";
import DestroyWallet from "./DestroyWalletModal";
import MustEnable2Fa from "../../../cubbyComponents/modals/mustEnable2FA";
import MustRefreshPage from "./MustRefreshPage";
import Settings from "./Settings";
import ViewTransaction from "./ViewTransactionModal";
import CreateNewBobModal from "./CreateNewBob";
import TwoFactorTimeout from "./TwoFactorTimeoutModal";

import NwcModalSecure from "./NwcModalSecure";
import OurInvoiceWasPaid from "./OurInvoiceWasPaid";
import { BOB_MODALS } from "../../helpers/constants";
import PayAttemptSuccessful from "./PayAttemptSuccessful";
import SelectBobModal from "./SelectBobModal";
import NwcEntry from "./NwcEntry";
import PayAttemptFailed from "./PayAttemptFailed";
import PromoCodeModal from "./PromoCodeModal";
import SponsorshipModal from "./SponsorshipModal";
import CreateHoldInvoice from "./CreateHoldInvoice";
import HoldInvoiceNeedsDecision from "./HoldInvoiceNeedsDecision";
import HoldInvoiceWasAccepted from "./HoldInvoiceWasAccepted";

const BobModals = observer(({ bob }: { bob: Bob }) => {
  useEffect(() => {
    // console.log("modal:", bob.openModal);
  }, [bob.openModal]);
  return (
    <>
      <SetReceiveAmount bob={bob} />
      {bob.openModal === BOB_MODALS.OUR_INVOICE_WAS_PAID && (
        <OurInvoiceWasPaid bob={bob} />
      )}
      {bob.openModal === BOB_MODALS.PAY_ATTEMPT_WAS_SUCCESSFUL && (
        <PayAttemptSuccessful bob={bob} />
      )}
      {bob.openModal === BOB_MODALS.PAY_ATTEMPT_FAILED && (
        <PayAttemptFailed bob={bob} />
      )}

      {bob.openModal === BOB_MODALS.NWC_ENTRY && <NwcEntry bob={bob} />}
      <SetUserProvidedNostrPublicKey bob={bob} />
      <EditAliasModal bob={bob} />
      <DestroyWallet bob={bob} />
      <MustRefreshPage bob={bob} />
      <Settings bob={bob} />
      <ViewTransaction bob={bob} />
      <CreateNewBobModal bob={bob} />
      <TwoFactorTimeout bob={bob} />
      <NwcModalSecure bob={bob} />
      {bob.selectedNostrConnection && <SingleBobNostrConnection bob={bob} />}
      <SelectBobModal bob={bob} />
      <PromoCodeModal bob={bob} />
      <SponsorshipModal bob={bob} />
      {bob.openModal === BOB_MODALS.CREATE_HOLD_INVOICE && (
        <CreateHoldInvoice bob={bob} />
      )}
      <HoldInvoiceNeedsDecision bob={bob} />
      {bob.openModal === BOB_MODALS.HOLD_INVOICE_WAS_ACCEPTED && (
        <HoldInvoiceWasAccepted bob={bob} />
      )}
    </>
  );
});

export default BobModals;
